const reenquiredFilterSortReducer = (
    state = {},
    action: {
      type: "SET_REENQUIRED_FILTER_SORT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_REENQUIRED_FILTER_SORT":
        return { ...action.payload };
  
      default:
        return state;
    }
  };
  export default reenquiredFilterSortReducer;